import { VirtualCurrencySale } from 'api/virtual-currency-sale/types'
import { applications } from '../application/data'
import { placements } from '../placement/data'

export const virtualCurrencySales: VirtualCurrencySale[] = [
  {
    application: applications[0],
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    id: '1',
    multiplier: 1.5,
    placements: [placements[0]],
    startTime: '2029-05-07T22:55:13Z',
    endTime: '2029-06-28T18:02:39Z',
  },
  {
    application: applications[0],
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    id: '2',
    multiplier: 2,
    placements: [placements[1]],
    startTime: '2022-05-07T22:55:13Z',
    endTime: '2022-06-28T18:02:39Z',
  },
  {
    application: applications[0],
    createdAt: '2021-12-07T22:55:13Z',
    updatedAt: '2022-01-28T18:02:39Z',
    id: '3',
    multiplier: 3,
    placements: [],
    startTime: '2024-05-07T22:55:13Z',
    endTime: '2029-06-28T18:02:39Z',
  },
]
